export default __webpack_public_path__ + "static/media/DMSLogoBlue.2e04183d.svg";